import { useId } from 'react'

// Labelled control. `as` picks the element; children = <option>s for selects.
export default function Field({ label, hint, error, as = 'input', id, className = '', children, ...rest }) {
  const autoId = useId()
  const controlId = id || autoId
  const Control = as
  return (
    <div className={`cn-field ${className}`.trim()} data-invalid={error ? 'true' : 'false'}>
      {label && <label className="cn-field-label" htmlFor={controlId}>{label}</label>}
      <Control id={controlId} className="cn-input" {...rest}>{as === 'select' ? children : undefined}</Control>
      {error ? <span className="cn-field-error">{error}</span> : hint ? <span className="cn-field-hint">{hint}</span> : null}
    </div>
  )
}
